
import {getCurrentInstance} from 'vue'

export const baseUrl=(app)=>{
   

    const url = getCurrentInstance()?.appContext.config.globalProperties.$baseUrl
 
    return url
}
